"use client";

import Script from "next/script";
import AuthAwareHeader from "@/components/layout/AuthAwareHeader";
import TopFooter from "@/components/top/TopFooter";

// window.hbspt の型は src/types/hubspot.d.ts で一元定義する

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background">
      <AuthAwareHeader />
      <main className="pt-16">
        <div className="max-w-2xl mx-auto px-6 py-16">
          <h1 className="text-3xl font-bold text-on-surface mb-4 text-center">
            お問い合わせ
          </h1>
          <p className="text-on-surface-variant text-center mb-10">
            ご質問・ご要望がございましたら、以下のフォームよりお気軽にお問い合わせください。
          </p>
          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6">
            <div id="hubspot-form" />
          </div>
        </div>
      </main>
      <TopFooter />
      <Script
        src="https://js-na2.hsforms.net/forms/embed/v2.js"
        strategy="afterInteractive"
        onReady={() => {
          if (window.hbspt) {
            window.hbspt.forms.create({
              portalId: "8283520",
              formId: "0ef5ef16-6cb8-4312-9801-f678a04109be",
              region: "na2",
              target: "#hubspot-form",
            });
          }
        }}
      />
    </div>
  );
}
